import {
  serverTimestamp,
  collection,
  addDoc,
  doc,
  setDoc,
  deleteDoc,
} from "firebase/firestore";
import { firestore } from "services/firebase/firebase";
import { store } from "redux/store";
import { SUBDOMAIN } from "services/Auth";
import { channelNameToUrlSlug } from "utils/channelSlug";

function getSubdomain() {
  try {
    const state = store.getState();
    const subdomain = state?.teamState?.config?.subdomain;
    if (subdomain) return subdomain;
  } catch (e) {
    // ignore
  }
  return SUBDOMAIN || "dev";
}

function getUser() {
  try {
    const state = store.getState();
    return state?.userState?.profile || null;
  } catch (e) {
    return null;
  }
}

/**
 * Notifica atualização do canal no Firestore (real-time para outros clientes).
 * @param {string} channelId
 * @param {Object} [lastMessage] - { content, authorName, authorId }
 * @param {string} [channelName]
 */
export async function notifyChannelUpdate(
  channelId,
  lastMessage,
  channelName
) {
  if (!firestore) {
    console.warn("Firestore não inicializado (configuração Firebase ausente)");
    return;
  }
  try {
    const subdomain = getSubdomain();
    const user = getUser();

    const channelsCollectionRef = collection(
      firestore,
      `chat_rooms/${subdomain}/channels`
    );

    const now = new Date();
    const formattedDate = now.toLocaleString("pt-BR", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });

    const slug = channelNameToUrlSlug(channelName);
    const channelUrl = `/channel/${channelId}/${slug}`;

    const baseData = {
      channelId: Number(channelId),
      channelName: channelName || "Canal",
      channelUrl,

      lastMessage: lastMessage
        ? {
            data: lastMessage.content,
            sentAt: formattedDate,
            sentBy: Number(lastMessage.authorId),
            type: "Text",
          }
        : null,

      senderInfo: {
        img:
          user?.img ||
          user?.avatar ||
          "https://cdn1.beedoo.io/prod/static/img/user_pic.jpg",
        name: user?.name || lastMessage?.authorName,
        userName: user?.username,
      },

      typeChannel: "Channel",
    };

    const eventData = {
      ...baseData,
      createdAt: now.toISOString(),
      updatedAt: serverTimestamp(),
      lastMessageTimestamp: serverTimestamp(),
    };

    await addDoc(channelsCollectionRef, eventData);
  } catch (error) {
    console.error("Erro ao notificar atualização do canal:", error);
    throw error;
  }
}

export function getTypingCollectionPath(channelId) {
  const subdomain = getSubdomain();
  return `chat_rooms/${subdomain}/typing/${channelId}/users`;
}

export function getTypingCollectionRef(channelId) {
  if (!firestore || !channelId) return null;
  const subdomain = getSubdomain();
  return collection(firestore, "chat_rooms", subdomain, "typing", String(channelId), "users");
}

export async function setTypingIndicator(channelId, isTyping) {
  if (!firestore || !channelId) return;
  const subdomain = getSubdomain();
  const user = getUser();
  const userId = user?.id ?? user?.userId;
  const name = user?.name ?? user?.userName ?? "Usuário";
  if (!userId) return;
  const userDocRef = doc(
    firestore,
    "chat_rooms",
    subdomain,
    "typing",
    String(channelId),
    "users",
    String(userId)
  );
  try {
    if (isTyping) {
      await setDoc(userDocRef, {
        userId: String(userId),
        name,
        updatedAt: serverTimestamp(),
      }, { merge: true });
    } else {
      await deleteDoc(userDocRef);
    }
  } catch (err) {
    if (err?.code !== "permission-denied") {
      console.warn("Erro ao atualizar indicador de digitação:", err);
    }
  }
}
